import { fAlertToast } from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import { common_WMSBinTransferReportAttributes_GETROW } from "../../Server/ApiV2";

export const sWebBinTransferReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebBinTransferReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];

export const sWebBetweenReportArr = [{ Uid: "Between", Value: "Btwn" }];

export const HeadObjectInit = {
  sDate: sWebBetweenReportArr[0].Uid,
  sLocation: "Is",
  sDocType: "All",
  sFromDate: new Date(),
  sToDate: new Date(),
  sDocNo_Input: "",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sStatus: "",
};

export const GetWMSMISAttributes = async (setLocationData, setStatusData) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var userCodeObj = {
    userCd: vRdxUserInfoObj.UserID,
  };
  const vResult = await common_WMSBinTransferReportAttributes_GETROW(
    userCodeObj
  );
  if (vResult?.status === 200) {
    setLocationData(vResult?.data?.ResultSet?.loc);
    setStatusData(vResult?.data?.ResultSet?.status);
    return vResult?.data?.ResultSet;
  }
};

export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sFromDate === "" ||
    HeadObject.sFromDate === null ||
    HeadObject.sFromDate === undefined ||
    HeadObject.sFromDate === "Invalid Date" ||
    HeadObject.sToDate === "" ||
    HeadObject.sToDate === null ||
    HeadObject.sToDate === undefined ||
    HeadObject.sToDate === "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sStatus === null ||
    HeadObject.sStatus === undefined ||
    HeadObject.sStatus === ""
  ) {
    fAlertToast("FAILED", "Status should not be empty");

    iRes = false;
    return iRes;
  }

  return iRes;
};
export const fValidationDetail_Client = (sBufferObj) => {
  let iRes = true;
  if (
    sBufferObj.sDetailReportRadioBtnName === "" ||
    sBufferObj.sDetailReportRadioBtnName === null ||
    sBufferObj.sDetailReportRadioBtnName === undefined
  ) {
    fAlertToast("FAILED", "DetailReport should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
